import { render } from "./HTMLParagraphElement4.vue?vue&type=template&id=3cf69787"
const script = {}

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__